module.exports = __webpack_public_path__ + "img/quarantine-mobile-bg.4d0c4f18.png";